import { http } from "../api/http";
import Utils from "../utils";

export const analyticsService = {
  getExecutionsThisMonth,
  getExecutionStats,
  getExecutionTrends,
  getMostCalledApiSystems,
  getApiFailureRates,
  getRecordsProcessedByApi,
  getDashboardStats,
  getExecutionDetail,
  getExecutionLines,
  getRunbookOverview,
  getRunbookExecutions,
  getApiRecords: getRecordsProcessedByApi,
  // Super User endpoints
  getSuperUserDashboard,
  getAllClientsAnalytics,
};

async function getExecutionsThisMonth() {
  const url = `/analytics/executions/month`;
  const response = await http.get(url);
  return response;
}

async function getExecutionStats(requestParameters) {
  const url = `/analytics/executions/stats?${Utils.objectToQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getExecutionTrends(requestParameters) {
  const url = `/analytics/executions/trends?${Utils.objectToQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getMostCalledApiSystems(requestParameters) {
  const url = `/analytics/api/usage?${Utils.objectToQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getApiFailureRates(requestParameters) {
  const url = `/analytics/api/failures?${Utils.objectToQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getRecordsProcessedByApi(requestParameters) {
  const url = `/analytics/api/records?${Utils.objectToQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getDashboardStats(requestParameters) {
  const url = `/analytics/dashboard?${Utils.objectToQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getExecutionDetail(requestParameters) {
  const executionId = requestParameters.executionId;
  const params = { ...requestParameters };
  delete params.executionId;
  const url = `/analytics/executions/${executionId}?${Utils.objectToQueryString(params)}`;
  const response = await http.get(url);
  return response;
}

async function getExecutionLines(executionId) {
  const url = `/analytics/executions/${executionId}/lines`;
  const response = await http.get(url);
  return response;
}

async function getRunbookOverview(requestParameters) {
  const url = `/analytics/runbooks/overview?${Utils.objectToQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getRunbookExecutions(requestParameters) {
  const runbookId = requestParameters.runbookId;
  const params = { ...requestParameters };
  delete params.runbookId;
  const url = `/analytics/runbooks/${runbookId}/executions?${Utils.objectToQueryString(params)}`;
  const response = await http.get(url);
  return response;
}

// Super User Analytics Endpoints

async function getSuperUserDashboard(requestParameters) {
  const url = `/analytics/superuser/dashboard?${Utils.objectToQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getAllClientsAnalytics(requestParameters) {
  const url = `/analytics/superuser/clients?${Utils.objectToQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}
